import { NumberInput, NumberInputProps } from '@vtex/admin-ui-form'
import { truncateDecimals } from '../NumberInput/truncateDecimals'

const DECIMAL_DIGITS = 0

type Limits = {
  min?: number
  max?: number
}

/**
 * NumberInput abstraction to accept only integer values.
 */
export function IntegerInput(props: NumberInputProps & Limits) {
  const { name, state } = props

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(event.target.value)
    const truncatedValue = truncateDecimals(value, DECIMAL_DIGITS)

    state.setValue(name, truncatedValue)
  }

  const handleBlur = () => state.trigger(name)

  return (
    <NumberInput
      onChangeCapture={handleChange}
      onBlurCapture={handleBlur}
      {...props}
    />
  )
}
